import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import styles from "./Navbars.module.scss";
import { Menubar } from "primereact/menubar";
import logo from "../../assets/eksiogluPictures/eksiogluWhiteLogo.png";
import onlineRandevu from "../../assets/eksiogluPictures/eksiogluPortal.png";
import { Button, Container, Navbar } from "reactstrap";
import classNames from "classnames";
import { useSize } from "components/SizeControl/SizeControl";
import PortalModal from "components/Modals/PortalModal";
import { PiBankDuotone } from "react-icons/pi";
import { FiInfo } from "react-icons/fi";

const WhiteNavbar = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const handleClick = (e) => {
    e.preventDefault();
    setModalVisible(true);
  };

  const { above960 } = useSize();
  let scrollSize = 640;
  const [navbarColor, setNavbarColor] = useState(
    (document.documentElement.scrollTop > scrollSize ||
      document.body.scrollTop) > scrollSize
      ? " navbar-deneme"
      : " navbar-deneme",
  );
  const [buyButtonColor, setBuyButtonColor] = useState(
    (document.documentElement.scrollTop > scrollSize ||
      document.body.scrollTop) > scrollSize
      ? "info"
      : "neutral",
  );
  const [logoStyle, setLogoStyle] = useState(true);
  const [hovered, setHovered] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useEffect(() => {
    const updateNavbarColor2 = () => {
      if (
        document.documentElement.scrollTop > scrollSize ||
        document.body.scrollTop > scrollSize
      ) {
        setNavbarColor(" navbar-deneme");
        setBuyButtonColor("info");
        setLogoStyle(false);
      } else if (
        document.documentElement.scrollTop < scrollSize ||
        document.body.scrollTop < scrollSize
      ) {
        setNavbarColor(" navbar-deneme");
        setBuyButtonColor("neutral");
        setLogoStyle(true);
      }
    };
    window.addEventListener("scroll", updateNavbarColor2);
    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor2);
    };
  }, []);

  const toggleDropdowns = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const items = [
    {
      label: <div className="font-sans">ANA SAYFA</div>,
      icon: "pi pi-fw pi-home",
      command: () => {
        window.location.href = "/";
      },
    },
    {
      label: <div className="font-sans">HAKKIMIZDA</div>,
      icon: <FiInfo className="text-[18px] mr-[10px]" />,
      command: () => {
        window.location.href = "/hakkimizda";
      },
    },
    {
      label: <div className="font-sans">HİZMETLERİMİZ</div>,
      icon: "pi pi-fw pi-list",
      items: [
        {
          label: <div className="font-sans">SİGORTA (TAHKİM) HUKUKU</div>,
          command: () => {
            window.location.href = "/sigorta-tahkim-hukuku";
          },
        },
        {
          separator: true,
        },
        {
          label: <div className="font-sans">ÖZEL HUKUK</div>,
          items: [
            {
              label: "SÖZLEŞMELER VE BORÇLAR HUKUKU",
              command: () => {
                window.location.href =
                  "/ozel-hukuk/sozlesmeler-ve-borclar-hukuku";
              },
            },
            {
              separator: true,
            },
            {
              label: "AİLE HUKUKU",
              command: () => {
                window.location.href = "/ozel-hukuk/aile-hukuku";
              },
            },

            {
              separator: true,
            },
            {
              label: "GAYRİMENKUL HUKUKU",
              command: () => {
                window.location.href = "/ozel-hukuk/gayrimenkul-hukuku";
              },
            },

            {
              separator: true,
            },

            {
              label: "MİRAS HUKUKU",
              command: () => {
                window.location.href = "/ozel-hukuk/miras-hukuku";
              },
            },
            {
              separator: true,
            },
            {
              label: "TİCARET HUKUKU",
              command: () => {
                window.location.href = "/ozel-hukuk/ticaret-hukuku";
              },
            },
          ],
        },
        {
          label: <div className="font-sans">KAMU HUKUKU</div>,
          items: [
            {
              separator: true,
            },
            {
              label: <div className="font-sans">CEZA HUKUKU</div>,
              command: () => {
                window.location.href = "/kamu-hukuku/ceza-hukuku";
              },
            },
            {
              separator: true,
            },
            {
              label: <div className="font-sans">İDARE HUKUKU</div>,
              command: () => {
                window.location.href = "/kamu-hukuku/idare-hukuku";
              },
            },
            {
              separator: true,
            },
            {
              label: <div className="font-sans">VERGİ HUKUKU</div>,
              command: () => {
                window.location.href = "/kamu-hukuku/vergi-hukuku";
              },
            },
            {
              separator: true,
            },
            {
              label: <div className="font-sans">GÜMRÜK HUKUKU</div>,
              command: () => {
                window.location.href = "/kamu-hukuku/gumruk-hukuku";
              },
            },
            {
              separator: true,
            },
            {
              label: <div className="font-sans">VATANDAŞLIK HUKUKU</div>,
              command: () => {
                window.location.href = "/kamu-hukuku/vatandaslik-hukuku";
              },
            },
          ],
        },
        {
          label: <div className="font-sans">EKONOMİ VE TİCARET HUKUKU</div>,
          items: [
            {
              separator: true,
            },
            {
              label: <div className="font-sans">İCRA İFLAS HUKUKU</div>,
              command: () => {
                window.location.href =
                  "/ekonomi-ve-ticaret-hukuku/icra-iflas-hukuku";
              },
            },

            {
              separator: true,
            },
            {
              label: <div className="font-sans">REKABET HUKUKU</div>,
              command: () => {
                window.location.href =
                  "/ekonomi-ve-ticaret-hukuku/rekabet-hukuku";
              },
            },
            {
              separator: true,
            },
            {
              label: <div className="font-sans">DENİZ TİCARETİ HUKUKU</div>,
              command: () => {
                window.location.href =
                  "/ekonomi-ve-ticaret-hukuku/deniz-ticareti-hukuku";
              },
            },
            {
              separator: true,
            },

            {
              label: <div className="font-sans">FİKRİ MÜLKİYET HUKUKU</div>,
              command: () => {
                window.location.href =
                  "/ekonomi-ve-ticaret-hukuku/fikri-mulkiyet-hukuku";
              },
            },
          ],
        },
        {
          label: <div className="font-sans">SOSYAL VE İDARİ HUKUK</div>,
          items: [
            {
              separator: true,
            },
            {
              label: <div className="font-sans">TÜKETİCİ HUKUKU</div>,
              command: () => {
                window.location.href = "/sosyal-ve-idari-hukuk/tuketici-hukuku";
              },
            },
            {
              separator: true,
            },

            {
              label: (
                <div className="font-sans">İŞ VE SOSYAL GÜVENLİK HUKUKU</div>
              ),
              command: () => {
                window.location.href =
                  "/sosyal-ve-idari-hukuk/is-ve-sosyal-guvenlik-hukuku";
              },
            },
            {
              label: <div className="font-sans">SAĞLIK HUKUKU</div>,
              command: () => {
                window.location.href = "/sosyal-ve-idari-hukuk/saglik-hukuku";
              },
            },
            {
              separator: true,
            },
            {
              label: <div className="font-sans">SPOR HUKUKU</div>,
              command: () => {
                window.location.href = "/sosyal-ve-idari-hukuk/spor-hukuku";
              },
            },
          ],
        },
        {
          label: <div className="font-sans">TEKNOLOJİ VE İNTERNET HUKUKU</div>,
          items: [
            {
              separator: true,
            },
            {
              label: <div className="font-sans">BİLİŞİM HUKUKU</div>,
              command: () => {
                window.location.href =
                  "/teknoloji-ve-internet-hukuku/bilisim-hukuku";
              },
            },
            {
              separator: true,
            },
            {
              label: (
                <div className="font-sans">KİŞİSEL VERİLERİ KORUMA KANUNU</div>
              ),
              command: () => {
                window.location.href =
                  "/teknoloji-ve-internet-hukuku/kisisel-verilerin-korunmasi-hukuku";
              },
            },
          ],
        },
      ],
    },
    {
      label: <div className="font-sans">YÖNETİM KADROMUZ</div>,
      icon: "pi pi-fw pi-user",
      command: () => {
        window.location.href = "/ekibimiz";
      },
    },
    // {
    //   label: <div className="font-sans">FOTOĞRAF GALERİMİZ</div>,
    //   icon: "pi pi-images",
    //   command: () => {
    //     window.location.href = "/fotograflar";
    //   },
    // },
    {
      label: <div className="font-sans">MULTİMEDYA</div>,
      icon: "pi pi-fw pi-video",
      items: [
        {
          separator: true,
        },
        {
          label: <div className="font-sans">BLOG PAYLAŞIMLARI</div>,
          command: () => {
            window.location.href = "/blog";
          },
        },
        {
          separator: true,
        },
        {
          label: <div className="font-sans">GALERİMİZ</div>,
          command: () => {
            window.location.href = "/galeri";
          },
        },
      ],
    },
    {
      label: <div className="font-sans">İLETİŞİM</div>,
      icon: "pi pi-fw pi-envelope",
      command: () => {
        window.location.href = "/iletisim";
      },
    },
  ];

  // const start = ( //@TODO
  //   <Link to="/">
  //     <img
  //       // className={logoStyle ? `${styles.logo}` : `${styles.logo}`}
  //       src={logo3}
  //       alt="logo"
  //       width={200}
  //       height={60}
  //       title="EKŞİOĞLU HUKUK"
  //       loading="eager"
  //       rel="preload"
  //       className="w-[60px] "
  //     />
  //   </Link>
  // );

  const start = (
    <Link to="/">
      <img
        src={logo}
        alt="logo"
        title="EKŞİOĞLU HUKUK"
        loading="eager"
        rel="preload"
        style={{
          width: "60px",
          minWidth: "60px",
          objectFit: "contain",
        }}
      />
    </Link>
  );

  const end = (
    <div
      onClick={handleClick}
      style={{
        background: "linear-gradient(135deg, #1e293b, #4b5563)",
        color: "#ffffff",
        width: "154px",
        height: "51px",
        borderRadius: "10px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 1rem",
        fontWeight: 600,
        letterSpacing: "0.5px",
        boxShadow: "0 3px 6px rgba(0,0,0,0.35)",
        transition: "all 0.3s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background =
          "linear-gradient(135deg, #334155, #6b7280)";
        e.currentTarget.style.boxShadow = "0 5px 12px rgba(255,255,255,0.1)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background =
          "linear-gradient(135deg, #1e293b, #4b5563)";
        e.currentTarget.style.boxShadow = "0 3px 6px rgba(0,0,0,0.35)";
      }}
    >
      <PiBankDuotone size={20} />
      <div style={{ textAlign: "center", flex: 1 }} className="font-sans">
        <div style={{ fontSize: "0.95rem", lineHeight: "1.1" }}>EKŞİOĞLU</div>
        <div style={{ fontSize: "0.75rem", opacity: 0.85 }}>PORTAL</div>
      </div>
    </div>
  );

  const menubarClasses = classNames({
    scrolled: true,
    hovered: hovered,
    above960: above960,
  });

  return (
    <>
      <Navbar
        className={"fixed-top" + navbarColor}
        color="white"
        expand="lg"
        style={{
          paddingTop: "0px",
          paddingBottom: "5px",
          fontSize: "1rem",
          color: "white",
          justifyContent: "center",
          display: "flex",
          zIndex: "1000000",
          backgroundColor:
            "linear-gradient(135deg, #0F172A, #333333) !important",
        }}
      >
        <Menubar
          model={items}
          start={start}
          end={end}
          className={menubarClasses}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        />
      </Navbar>
      <PortalModal
        visible={modalVisible}
        onHide={() => setModalVisible(false)}
      />
    </>
  );
};

export default WhiteNavbar;
